// src/extenders/quantity-selector.js
var QuantitySelector = class extends HTMLElement {
  /**
   * Creates an instance of QuantitySelector
   * Initializes DOM elements and sets up event listeners
   */
  constructor() {
    super();
    this.select = this.querySelector("select[data-quantity-select]");
    this.enableDelete = this.getAttribute("data-enable-delete");
    if (this.select) {
      this.initEventListeners();
    }
  }
  /**
   * Sets up event listeners for the quantity selector
   */
  initEventListeners() {
    this.select.addEventListener("change", () => this.handleQuantityChange());
    this.addEventListener("click", (event) => {
      if (event.target !== this.select) {
        event.preventDefault();
        this.openSelect();
      }
    });
  }
  /**
   * Opens the select dropdown programmatically
   */
  openSelect() {
    this.select.focus();
    if (typeof this.select.showPicker === "function") {
      this.select.showPicker();
    } else {
      const event = new MouseEvent("mousedown", {
        bubbles: true,
        cancelable: true,
        view: window
      });
      this.select.dispatchEvent(event);
    }
  }
  /**
   * Handles quantity changes from the select element
   */
  handleQuantityChange() {
    const value = parseInt(this.select.value);
    this.dispatchChangeEvent(value);
  }
  /**
   * Dispatches a custom event when quantity changes
   * @fires QuantitySelector#quantity:changed
   */
  dispatchChangeEvent(value) {
    this.dispatchEvent(new CustomEvent("quantity:changed", {
      detail: {
        quantity: value
      },
      bubbles: true
    }));
  }
};
customElements.define("quantity-selector", QuantitySelector);
